import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillSingleTagSelectorV1FieldComponent } from './fill-single-tag-selector-v1/fill-single-tag-selector-v1.component';
import { ViewSingleTagSelectorV1FieldComponent } from './view-single-tag-selector-v1/view-single-tag-selector-v1.component';
import { SettingsSingleTagSelectorV1FieldComponent } from './settings-single-tag-selector-v1/settings-single-tag-selector-v1.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        LabelsModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillSingleTagSelectorV1FieldComponent,
        ViewSingleTagSelectorV1FieldComponent,
        SettingsSingleTagSelectorV1FieldComponent
    ],
    exports: [
        FillSingleTagSelectorV1FieldComponent,
        ViewSingleTagSelectorV1FieldComponent,
        SettingsSingleTagSelectorV1FieldComponent
    ],

})
export class CoreCustomFormsFieldSingleTagSelectorV1FieldsModule { }
